<div class="component-wrapper" id="main-content">
    <form class="form" (ngSubmit)="login()" [formGroup]="loginForm">
        <div class="benutzername">
            <kendo-formfield >
                <kendo-label class="form-label" [for]="benutzername" translate="auth.email"></kendo-label>
                <kendo-textbox #benutzername [placeholder]="'auth.email' | translate" formControlName="benutzername"
                    showSuccessIcon="initial" showErrorIcon="initial"></kendo-textbox>
                <kendo-formerror *ngFor="let errorMessage of benutzernameErrorMessages">{{errorMessage}}</kendo-formerror>
            </kendo-formfield>
        </div>

        <div class="password">
            <kendo-formfield >
                <kendo-label class="form-label" [for]="password" translate="auth.password"></kendo-label>
                <kendo-textbox #password type="password" [placeholder]="'auth.password' | translate" formControlName="passwort"
                    showSuccessIcon="initial" showErrorIcon="initial">
                    <ng-template kendoTextBoxSuffixTemplate>
                        <button type="button"
                        kendoButton
                        look="clear"
                        [title]="'toggle.password.visibility' | translate"
                        (click)="toggleVisibility(this.passwordTextBox)"
                        >
                        <kendo-svg-icon [icon]="icons.eye"></kendo-svg-icon></button>
                    </ng-template>
                </kendo-textbox>            
                <kendo-formerror *ngFor="let errorMessage of passwortErrorMessages">{{errorMessage}}</kendo-formerror>
            </kendo-formfield>
        </div>
        
        <div class="links">
            <a class="passwortVergessen" routerLink="/authentication/mailverification" routerLinkActive="active">
                <span translate>auth.forgot_password</span>
            </a>
            <a *ngIf="!isRegistrationDisabled" class="register" routerLink="/authentication/preregister" [queryParams]="{redirect: redirect}"
                routerLinkActive="active">
                <span translate>auth.register</span>
            </a>
        </div>

        <div class="submit-wrapper">
            <button kendoButton class="anmelden" type="submit" [disabled]="isAnmeldeButtonDisabled" [innerHTML]="'auth.login' |translate"></button>
        </div>
    </form>
</div>